import { render, staticRenderFns } from "./addCollectionRecord.vue?vue&type=template&id=0aaf5f4a&scoped=true"
import script from "./addCollectionRecord.vue?vue&type=script&lang=js"
export * from "./addCollectionRecord.vue?vue&type=script&lang=js"
import style0 from "./addCollectionRecord.vue?vue&type=style&index=0&id=0aaf5f4a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaf5f4a",
  null
  
)

export default component.exports